import script from "./UserAssignmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAssignmentModal.vue?vue&type=script&setup=true&lang=js"

import "./UserAssignmentModal.vue?vue&type=style&index=0&id=22a0a63b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a0a63b"]])

export default __exports__